import { JURISDICTIONS } from 'utils/constants/app/jurisdictions';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { assignPageUrls } from './assign-page-urls';
import { assignWebpSupport } from './assign-webp-support';
import { btagDetection } from './btag-detection';

export const configureSpring = (): void => {
  /**  JURISDICTIONS SECTION  **/
  if (SpringConfigs.JURISDICTION !== '0') {
    const jurisdictionFile = JURISDICTIONS[SpringConfigs.JURISDICTION];
    import(
      /* webpackChunkName: "jurisdiction-[request]" */ `utils/constants/jurisdictions/${jurisdictionFile}`
    ).then(jurisdiction => {
      Object.assign(SpringConfigs, jurisdiction.default);
    });
  }

  /**  PAGE_URLS SECTION  **/
  assignPageUrls();

  /**  WEBP SUPPORT SECTION  **/
  assignWebpSupport();

  /**  BTAG, LOYALTY CODE AND REFERENCE CODE SECTION  **/
  btagDetection();
};
